import {
  Document,
  Page,
  PDFViewer,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";

export const styles = StyleSheet.create({
  page: {
    paddingHorizontal: 30,
    paddingVertical: 15,
    fontFamily: "HostGrotesk",
    backgroundColor: "white",
  },
  fullpage: {
    margin: 7,
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#000000",
  },
  heading: {
    textAlign: "center",
  },
  sideBySideContainer: {
    display: "flex",
    flexDirection: "row",
  },
  shipper: {
    width: "60%",
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "65px",
  },
  consignee: {
    width: "60%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "95px",
  },
  notify: {
    width: "60%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "95px",
  },
  notify2: {
    width: "40%",
    borderBottomWidth: 1,
    height: "95px",
  },
  largeText: {
    fontSize: 8,
  },
  boldText: {
    fontWeight: "bold",
    fontSize: 10,
  },
  bookingNo: {
    borderTopWidth: 1,
    width: "40%",
    borderBottomWidth: 1,
    height: "65px",
  },
  empty: {
    borderBottomWidth: 1,
    width: "40%",
  },
  placeOfReceipt: {
    width: "27%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "32px",
  },
  vessel: {
    width: "33%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "32px",
  },
  portOfLoading: {
    width: "27%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "32px",
  },
  portOfDischarge: {
    width: "33%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "32px",
  },
  finalDestination: {
    width: "23%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "32px",
  },
  empty4: {
    borderBottomWidth: 1,
    width: "17%",
    textAlign: "center",
  },
  marksAndNumbers: {
    width: "27%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "20px",
    textAlign: "center",
  },
  descriptionOfGoods: {
    width: "46%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    textAlign: "center",
    height: "20px",
  },
  weight: {
    width: "10%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "20px",
    textAlign: "center",
  },
  marksAndNumbers2: {
    width: "27%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "150px",
  },
  descriptionOfGoods2: {
    width: "46%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "150px",
  },
  weight2: {
    width: "10%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "150px",
  },
  measurement: {
    borderBottomWidth: 1,
    width: "17%",
    height: "150px",
  },
  srno: {
    width: "10%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "15px",
    textAlign: "center",
  },
  container: {
    width: "17%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "15px",
    textAlign: "center",
  },
  lineSeal: {
    width: "14%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "15px",
    textAlign: "center",
  },
  pkgs: {
    width: "8%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "15px",
    textAlign: "center",
  },
  grossWt: {
    width: "12%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "15px",
    textAlign: "center",
  },
  netWt: {
    width: "12%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "15px",
    textAlign: "center",
  },
  size: {
    width: "10%",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    height: "15px",
    textAlign: "center",
  },
  empty5: {
    borderBottomWidth: 1,
    width: "17%",
    height: "15px",
    textAlign: "center",
  },
  weightData: {
    height: "70px",
    textAlign: "center",
    borderBottomWidth: 1,
  },
  weightData2: {
    height: "30px",
    textAlign: "center",
    borderBottomWidth: 1,
  },
  weightData3: {
    height: "30px",
    textAlign: "center",
  },
});

const BlDraftInvoice2 = () => {
  return (
    <PDFViewer width="100%" height="800px">
      <Document>
        <Page style={styles.page} size="A4">
          <View style={styles.fullpage}>
            <Text style={[styles.heading]}>BL DRAFT</Text>
            <View style={[styles.sideBySideContainer]}>
              <View style={[styles.shipper]}>
                <Text style={[styles.boldText, { left: 5, top: 3 }]}>
                  SHIPPER :
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 3 }]}>
                  MS LAXMI ENTERPRISE
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 3 }]}>
                  PLOT NO. 612, NAGOR ROAD,
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 3 }]}>
                  GIDC BHUJ, KACHCHH
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 3 }]}>
                  GUJARAT, 370001 (INDIA)
                </Text>
              </View>
              <View style={[styles.bookingNo]}>
                <Text style={[styles.boldText, { left: 5, top: 3 }]}>
                  BOOKING NO.
                </Text>
                <Text style={[styles.largeText, { top: 12, left: 5 }]}>
                  189FX000483
                </Text>
                <Text style={[styles.largeText, { top: 20, left: 5 }]}>
                  LINE : WANHAI
                </Text>
              </View>
            </View>
            <View style={[styles.sideBySideContainer]}>
              <View style={[styles.consignee]}>
                <Text style={[styles.boldText, { left: 5, top: 3 }]}>
                  CONSIGNEE :
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 3 }]}>
                  PT BERKAT JAYA ONGGUL
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 3 }]}>
                  JALAN ROMOKALISARI 82B,
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 3 }]}>
                  BENWO, SURABAYA,
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 3 }]}>
                  60192, INDONESIA
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 3 }]}>
                  NPWP : 0759 2123 1960 4000
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 3 }]}>
                  TAX ID: TEX123456
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 3 }]}>
                  CONTACT NAME: JHON DOE
                </Text>
              </View>
              <View style={[styles.empty]}></View>
            </View>
            <View style={[styles.sideBySideContainer]}>
              <View style={[styles.notify]}>
                <Text style={[styles.boldText, { left: 5, top: 3 }]}>
                  NOTIFY :
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 3 }]}>
                  PT BERKAT JAYA ONGGUL
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 3 }]}>
                  JALAN ROMOKALISARI 82B,
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 3 }]}>
                  BENOWO, SAURABAYA,
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 3 }]}>
                  60192, INDONESIA
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 3 }]}>
                  NPWP : 0759 2123 1960 4000
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 3 }]}>
                  TAX ID: TEX123456
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 3 }]}>
                  CONTACT NAME: JHON DOE
                </Text>
              </View>
              <View style={[styles.notify2]}>
                <Text style={[styles.boldText, { left: 5, top: 3 }]}>
                  NOTIFY 2 :
                </Text>
              </View>
            </View>
            <View style={[styles.sideBySideContainer]}>
              <View style={[styles.placeOfReceipt]}>
                <Text style={[styles.boldText, { left: 5, top: 2 }]}>
                  PLACE OF RECEIPT :
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 2 }]}>
                  MUDRA , INDIA
                </Text>
              </View>
              <View style={[styles.vessel]}>
                <Text style={[styles.boldText, { left: 5, top: 2 }]}>
                  VESSEL :
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 2 }]}>
                  INTERASIA PROGRESS / E095
                </Text>
              </View>
              <View style={[styles.empty]}></View>
            </View>
            <View style={[styles.sideBySideContainer]}>
              <View style={[styles.portOfLoading]}>
                <Text style={[styles.boldText, { left: 5, top: 2 }]}>
                  PORT OF LOADING :
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 2 }]}>
                  MUDRA, INDIA
                </Text>
              </View>
              <View style={[styles.portOfDischarge]}>
                <Text style={[styles.boldText, { left: 5, top: 2 }]}>
                  PORT OF DISCHARGE :
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 2 }]}>
                  SURABAYA, INDONESIA
                </Text>
              </View>
              <View style={[styles.finalDestination]}>
                <Text style={[styles.boldText, { left: 5, top: 2 }]}>
                  FINAL DESTINATION :
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 2 }]}>
                  SURABAYA, INDONESIA
                </Text>
              </View>
              <View style={[styles.empty4]}></View>
            </View>
            <View style={[styles.sideBySideContainer]}>
              <View style={[styles.marksAndNumbers]}>
                <Text style={[styles.boldText, { top: 2 }]}>
                  MARKS & NUMBERS
                </Text>
              </View>
              <View style={[styles.descriptionOfGoods]}>
                <Text style={[styles.boldText, { top: 2 }]}>
                  DESCRIPTION OF GOODS
                </Text>
              </View>
              <View style={[styles.weight]}>
                <Text style={[styles.boldText, { top: 2 }]}>WEIGHT</Text>
              </View>
              <View style={[styles.empty4]}>
                <Text style={[styles.boldText, { top: 2 }]}>MEASUREMENT</Text>
              </View>
            </View>
            <View style={[styles.sideBySideContainer]}>
              <View style={[styles.marksAndNumbers2]}></View>
              <View style={[styles.descriptionOfGoods2]}>
                <Text style={[styles.largeText, { left: 5, top: 5 }]}>
                  03x20' FCL CONTAINERS
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 5 }]}>
                  TOTAL 1170 BAGS
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 5 }]}>
                  HS CODE: 120242
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 5 }]}>
                  INDIAN GROUNDNUT KERNELS
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 5 }]}>
                  (PACKED IN NEW JUTE BAGS) NET 50 KGS
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 5 }]}>
                  & GRO S S 50.5 KGS EACH BAG.
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 5 }]}>
                  INVOICE NO. LE/EXP/24-25/089 DATE:27/01/2025
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 5 }]}>
                  SB NO. 58.500 MTS
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 5 }]}>
                  NET WT. 58.500 MTS
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 5 }]}>
                  GROSS WT. 59.085 MTS
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 5 }]}>
                  14 DAYS FREE AT POD.
                </Text>
                <Text style={[styles.largeText, { left: 5, top: 5 }]}>
                  FREIGHT PREPAID.
                </Text>
              </View>
              <View style={[styles.weight2]}>
                <View style={[styles.weightData]}>
                  <Text style={[styles.largeText, { top: 2 }]}>
                    TOTAL {"\n"} GROSS WT {"\n"} 59085.000{"\n"} KGS
                  </Text>
                </View>
                <View style={[styles.weightData2]}></View>
                <View style={[styles.weightData]}>
                  <Text style={[styles.largeText, { top: 2 }]}>
                    TOTAL {"\n"} NET WT {"\n"} 59085.000{"\n"} KGS
                  </Text>
                </View>
                <View style={[styles.weightData3]}></View>
              </View>
              <View style={[styles.measurement]}></View>
            </View>
            <View style={[styles.sideBySideContainer]}>
              <View style={[styles.srno]}>
                <Text style={[styles.boldText]}>SR NO</Text>
              </View>
              <View style={[styles.container]}>
                <Text style={[styles.boldText]}>CONTAINER</Text>
              </View>
              <View style={[styles.lineSeal]}>
                <Text style={[styles.boldText]}>LINE SEAL</Text>
              </View>
              <View style={[styles.pkgs]}>
                <Text style={[styles.boldText]}>PKGS</Text>
              </View>
              <View style={[styles.grossWt]}>
                <Text style={[styles.boldText]}>GROSS WT</Text>
              </View>
              <View style={[styles.netWt]}>
                <Text style={[styles.boldText]}>NET WT</Text>
              </View>
              <View style={[styles.size]}>
                <Text style={[styles.boldText]}>SIZE</Text>
              </View>
              <View style={[styles.empty5]}>
                <Text style={[styles.boldText]}></Text>
              </View>
            </View>
            <View style={[styles.sideBySideContainer]}>
              <View style={[styles.srno]}>
                <Text style={[styles.largeText, { top: 1 }]}>1</Text>
              </View>
              <View style={[styles.container]}>
                <Text style={[styles.largeText, { top: 1 }]}> WHLU0484689</Text>
              </View>
              <View style={[styles.lineSeal]}>
                <Text style={[styles.largeText, { top: 1 }]}>WHLY139297</Text>
              </View>
              <View style={[styles.pkgs]}>
                <Text style={[styles.largeText, { top: 1 }]}>390</Text>
              </View>
              <View style={[styles.grossWt]}>
                <Text style={[styles.largeText, { top: 1 }]}>19695.00</Text>
              </View>
              <View style={[styles.netWt]}>
                <Text style={[styles.largeText, { top: 1 }]}>19500.00</Text>
              </View>
              <View style={[styles.size]}>
                <Text style={[styles.largeText, { top: 1 }]}>20'</Text>
              </View>
              <View style={[styles.empty5]}>
                <Text style={[styles.largeText, { top: 1 }]}></Text>
              </View>
            </View>
            <View style={[styles.sideBySideContainer]}>
              <View style={[styles.srno]}>
                <Text style={[styles.largeText, { top: 1 }]}>2</Text>
              </View>
              <View style={[styles.container]}>
                <Text style={[styles.largeText, { top: 1 }]}> WHLU2495158</Text>
              </View>
              <View style={[styles.lineSeal]}>
                <Text style={[styles.largeText, { top: 1 }]}>WHLY139298</Text>
              </View>
              <View style={[styles.pkgs]}>
                <Text style={[styles.largeText, { top: 1 }]}>390</Text>
              </View>
              <View style={[styles.grossWt]}>
                <Text style={[styles.largeText, { top: 1 }]}>19695.00</Text>
              </View>
              <View style={[styles.netWt]}>
                <Text style={[styles.largeText, { top: 1 }]}>19500.00</Text>
              </View>
              <View style={[styles.size]}>
                <Text style={[styles.largeText, { top: 1 }]}>20'</Text>
              </View>
              <View style={[styles.empty5]}>
                <Text style={[styles.largeText, { top: 1 }]}></Text>
              </View>
            </View>
            <View style={[styles.sideBySideContainer]}>
              <View style={[styles.srno]}>
                <Text style={[styles.largeText, { top: 1 }]}>3</Text>
              </View>
              <View style={[styles.container]}>
                <Text style={[styles.largeText, { top: 1 }]}> WHLU2408153</Text>
              </View>
              <View style={[styles.lineSeal]}>
                <Text style={[styles.largeText, { top: 1 }]}>WHLY139299</Text>
              </View>
              <View style={[styles.pkgs]}>
                <Text style={[styles.largeText, { top: 1 }]}>390</Text>
              </View>
              <View style={[styles.grossWt]}>
                <Text style={[styles.largeText, { top: 1 }]}>19695.00</Text>
              </View>
              <View style={[styles.netWt]}>
                <Text style={[styles.largeText, { top: 1 }]}>19500.00</Text>
              </View>
              <View style={[styles.size]}>
                <Text style={[styles.largeText, { top: 1 }]}>20'</Text>
              </View>
              <View style={[styles.empty5]}>
                <Text style={[styles.largeText, { top: 1 }]}></Text>
              </View>
            </View>
            <View style={[styles.sideBySideContainer]}>
              <View
                style={{
                  width: "10%",
                  borderRightWidth: 1,
                  height: "15px",
                  textAlign: "center",
                }}
              >
                <Text style={[styles.boldText]}></Text>
              </View>
              <View
                style={{
                  width: "17%",
                  borderRightWidth: 1,
                  height: "15px",
                  textAlign: "center",
                }}
              >
                <Text style={[styles.boldText]}> TOTAL </Text>
              </View>
              <View
                style={{
                  width: "14%",
                  borderRightWidth: 1,
                  height: "15px",
                  textAlign: "center",
                }}
              >
                <Text style={[styles.boldText]}></Text>
              </View>
              <View
                style={{
                  width: "8%",
                  borderRightWidth: 1,
                  height: "15px",
                  textAlign: "center",
                }}
              >
                <Text style={[styles.boldText]}>1170</Text>
              </View>
              <View
                style={{
                  width: "12%",
                  borderRightWidth: 1,
                  height: "15px",
                  textAlign: "center",
                }}
              >
                <Text style={[styles.boldText]}>59085.000</Text>
              </View>
              <View
                style={{
                  width: "12%",
                  borderRightWidth: 1,
                  height: "15px",
                  textAlign: "center",
                }}
              >
                <Text style={[styles.boldText]}>58500.000</Text>
              </View>
              <View
                style={{
                  width: "10%",
                  borderRightWidth: 1,
                  height: "15px",
                  textAlign: "center",
                }}
              >
                <Text style={[styles.boldText]}></Text>
              </View>
              <View
                style={{
                  width: "17%",
                  height: "15px",
                  textAlign: "center",
                }}
              >
                <Text
                  style={[styles.boldText]}
                ></Text>
              </View>
            </View>
          </View>
        </Page>
      </Document>
    </PDFViewer>
  );
};
export default BlDraftInvoice2;
